'use strict';
import modalObservacionController from '../ejecutar-transicion/observacion.modal.controller.js';
import modalObservacionTemplate from '../ejecutar-transicion/observacion.modal.html';


import modalModificacionesController from '../../bandeja/supervisiones/modificaciones.modal.controller';
import modalModificacionesTemplate from '../../bandeja/supervisiones/modificaciones.modal.html';

import modalModificacionesAdjudicacionController from '../../bandeja/modificaciones/modal.controller';
import modalModificacionesAdjudicacionTemplate from '../../bandeja/modificaciones/modal.html';

import modalSupervisionesController from '../../bandeja/supervisiones/supervisiones.modal.controller';
import modalSupervisionesTemplate from '../../bandeja/supervisiones/supervisiones.modal.html';
class SeguimientoController{
	constructor(DataService, Proyecto,Loading,Message,Storage,$state,Modal,Usuarios){
		'ngInject';
		this.DataService = DataService;
		this.Proyecto = Proyecto;
		this.Loading = Loading;
		this.Message = Message;
		this.Storage = Storage;
		this.$state = $state;
		this.Modal = Modal;
		this.Usuarios = Usuarios;
	}
	$onInit(){
		this.items = [
			{value: 1, text: 'Medio Termino'},
			{value: 2, text: 'Final'}
		];
		this.valorMinimo = "0"
		
		this.tipos_plazo_ampliado = [{
			codigo: 'Convenio modificatorio',
			nombre: 'Convenio modificatorio'
		},{
			codigo: 'Adenda al convenio',
			nombre: 'Adenda al convenio'
		}];	

		// console.log(this)
		// setTimeout(()=>{
		// 	console.log(this.proyecto)
		// },1000)
		// console.log(this.proyecto)
		this.usuario = this.Storage.getUser();

		this.calcularPlazos();
		
		// console.log("plazo_convenio0 : ",this.plazo_convenio0)

		// popover dinamico
		this.dynamicPopover = {
			content: 'Hello, World!',
			templateUrl: 'myPopoverTemplate.html',
			title: 'Titulo de popover'
		};
		this.dynamicPopover2 = {
			content: 'Hello, World!',
			templateUrl: 'myPopoverTemplate2.html',
			title: 'Titulo de popover'
		};
		this.recalcularPlazoConvenio1();
		this.recalcularPlazoConvenio2();
		this.recalcularPlazoConvenio3();
		this.recalcularPlazoConvenio4();
		this.recalcularPlazoConvenio5();
		this.recalcularPlazoConvenio6();
		this.recalcularPlazoConvenio7();
		this.recalcularPlazoConvenio8();
		this.recalcularPlazoConvenio9();
		this.recalcularPlazoConvenio10();
		this.recalcularPlazoConvenio11();
		this.recalcularPlazoConvenio12();
		this.recalcularPlazoConvenio13();
		this.recalcularPlazoConvenio14();
		// let thislocal = this;
		// console.log('seguimiento controller..', this.proyecto)

		// setTimeout(()=>{
		// console.log(this.proyecto,"<--------")
		// if(!this.proyecto.inspecciones){
		// 	this.proyecto.inspecciones = {}
		// }
		// if(!this.proyecto.seguimiento){
		// 	this.proyecto.seguimiento = {}
		// }
		// },1500)
		setTimeout(()=>{
			if(this.proyecto.seguimiento.avance_fis && (this.proyecto.seguimiento.avance_fis.length > 0)){
				this.valorMinimo = this.proyecto.seguimiento.avance_fis[this.proyecto.seguimiento.avance_fis.length - 1].porcentaje.toString();
			}
			this.archivos = {
				urlDocActaProv: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ACP` : '',
				urlDocActaProvDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ACP/descargar` : '',
				urlDocActaDef: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ACD` : '',
				urlDocActaDefDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ACD/descargar` : '',
				urlDocIT: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/IT` : '',
				urlDocITDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/IT/descargar` : '',
				urlDocLMT: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/LMT` : '',
				urlDocLMTDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/LMT/descargar` : '',
			};

			this.DataService.get(`proyectos/${this.proyecto.id_proyecto}/usuarios`)
			.then(response => {
				if (response) {
					this.usuariosParaAsignar = [];
					for(let i in response.datos) {
						response.datos[i].nom = response.datos[i].nombre.split("(")[0]
						this.usuariosParaAsignar.push(response.datos[i]);

						// if (response.datos[i].id_usuario==this.proyecto.fid_usuario_asignado && response.datos[i].id_rol==this.proyecto.fid_usuario_asignado_rol) {
						// 	this.usuario_asignado = this.usuariosParaAsignar[i];
						// }
					}
				}
			});
			
		},4500)

		
	}

	// extraerProyecto(){
	// 	console.log("INICIANDO COMPONENTE SEGUIMIENTO CONTROLLERs");
	// 	console.log(this.proyecto,"EXTRAYENDO DATOS DE PROYECTO")
	// 	if (!this.proyecto.inspecciones){
	// 		this.proyecto.inspecciones = {}
	// 	}
	// 	if (!this.proyecto.seguimiento){
	// 		this.proyecto.seguimiento = {}
	// 	}
	// }
	obtenerInspeccion(value){
		if (!value) {
			this.Message.warning(`No se encontro el documento`);
			return;
		}
		let exreg = /\[(.*?)\]\s*(.*)/;
		let codigo = value.split(exreg)[1];
		this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/${codigo}`,value);
	}

	descargarInspeccion(index){
		return `proyectos/${this.proyecto.id_proyecto}/doc/IC_${index}/descargar`
	}

	verAdenda(codigo){
		this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/${codigo}`, `Documento ${codigo}`);
	}

	addAf(value){
		if (!value) {
			value=[];
		}
		for(let i in value){
			// console.log(value[i].id_avance_fisico,"<<")
			if (!value[i].id_avance_fisico || value[i].edicion) {
				// console.log(value[i].id_avance_fisico, value[i].edicion)
				this.Message.warning(`Debe guardar el registro antes de crear otro`);
				return;
			}
		}
		value.push({edicion: true, porcentaje:value.length?value[value.length-1].porcentaje:0})
		// console.log("value: ", value)

	}
puedeVerModificaciones(proyecto) {
    if (!proyecto.orden_proceder)
      return false;
    if ((this.Usuarios.esSupervisor() || this.Usuarios.esFiscal() || this.Usuarios.esResponsableGAM() || this.Usuarios.esTecnicoResponsable() || this.Usuarios.esVisorReportes()) && ['EN_EJECUCION_FDI'].indexOf(proyecto.estado_proyecto) !== -1)
      return true;
    return false;
  }

irAModificaciones(proyecto) {
	if (proyecto.adjudicaciones.length > 1) {
		if (proyecto.id_proyecto > 0) {
			this.Modal.show({
				template: modalModificacionesTemplate,
				controller: modalModificacionesController,
				data: proyecto,
				size: 'lg'
			});
		}
	} else {
		proyecto.adjudicacion = proyecto.adjudicaciones[0];
		this.Modal.show({
			template: modalModificacionesAdjudicacionTemplate,
			controller: modalModificacionesAdjudicacionController,
			data: proyecto,
			size: 'lg'
		});
	}
}

	verSupervisiones() {
	this.Modal.show({
		template: modalSupervisionesTemplate,
		controller: modalSupervisionesController,
		data: this.proyecto,
		size: 'lg'
	});
	}

	puedeVerSupervision(proyecto) {
		if(proyecto) {
			return ['APROBADO','EN_EJECUCION_FDI','REVISION_SEGUIMIENTO_FDI','ASIGNACION_TECNICO_CIERRE_FDI','EN_CIERRE_FDI','CERRADO','MODIFICADO','PARALIZADO'].indexOf(proyecto.estado_proyecto)>=0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
		}
		return false;
	}

	addIc(value){
		if (!value) {
			value=[];
		}
		for(let i in value){
			// console.log(value[i].id_avance_fisico,"<<")
			if (!value[i].id_inspeccion_campo || value[i].edicion) {
				// console.log(value[i].id_avance_fisico, value[i].edicion)
				this.Message.warning(`Debe guardar el registro antes de crear otro`);
				return;
			}
		}
		value.push({edicion: true})


	}
	guardarDatos(){
		// console.log(this.proyecto)
		// console.log(this.proyecto,"proyecto seguimiento")
		this.datos = {
			fid_proyecto: this.proyecto.id_proyecto,
			impacto: this.proyecto.seguimiento.impacto,
			fecha_acta_provisional: this.proyecto.seguimiento.fecha_acta_provisional,
			doc_acta_provisional: this.proyecto.seguimiento.doc_acta_provisional,
			fecha_acta_definitiva: this.proyecto.seguimiento.fecha_acta_definitiva,
			doc_acta_definitiva: this.proyecto.seguimiento.doc_acta_definitiva,
			fecha_informe : this.proyecto.seguimiento.fecha_informe,
			doc_informe: this.proyecto.seguimiento.doc_informe,
			fecha_ley_mun: this.proyecto.seguimiento.fecha_ley_mun,
			doc_ley_mun: this.proyecto.seguimiento.doc_ley_mun,
			_usuario_creacion: this.usuario.id_usuario
		};


		// console.log('datos para enviar : ', this.datos)
		this.Loading.show('Guardando',true)
		this.DataService.post(`proyectos/seg`, this.datos)
			.then(response=>{
				if(response){
					this.Message.success("Proyecto actualizado correctamente.");
					this.proyecto.seguimiento = response.datos
					// console.log("datos recibidos despues de guardar: ",this.proyecto)
					
					this.Loading.hide();
					this.$state.reload();			
				}
			})
	}

	actualizarInspeccion(value){
		// solo actualiza la fecha del informe
		this.DataService.put(`proyectos/inspeccion/${value.id_inspeccion_campo}`, value)
			.then(response=>{
				if (response) {
					this.Message.success("Actualizado correctamente.");
					value.tecnico_inspeccion = value.tecnico_inspeccion.nom
					value.detalle = value.text
				}
			})
		value.edicion = false;
	}
	guardarInspeccion(value,index){
		// Guardar inspeccion de campo
		value.objeto_id= this.proyecto.seguimiento.id_seguimiento;
		value.id_proyecto = this.proyecto.id_proyecto;
		value.cant_inspec = this.proyecto.seguimiento.inspeccion_campo.length;
		value.tipo_inspeccion = 'seguimiento';
		if (!this.sonDatosValidosInspeccion(index)) {
			return;
		}
		this.DataService.post(`proyectos/inspeccion`,value)
			.then(response=>{
				if (response) {
					// console.log(response)
					value.id_inspeccion_campo= response.datos.id_inspeccion_campo;
					value.fecha = response.datos.fecha;
					value.doc_informe = response.datos.doc_informe;
					value.detalle = response.datos.detalle;
					value.tecnico_inspeccion = response.datos.tecnico_inspeccion;
					this.Message.success("guardado correctamente.");
				}
			})
		value.edicion = false;
	}

	eliminarInspeccion(value,index){
		// Elimina la inspeccion de campo
		if (!value.id_inspeccion_campo) {
		this.proyecto.seguimiento.inspeccion_campo.splice(index, 1);
		return;
		}
	}

	guardarAvance(value,index){
		// Guarda el avance fisico
		value.id_seguimiento = this.proyecto.seguimiento.id_seguimiento;
		value.id_proyecto = this.proyecto.id_proyecto;
		if (!this.sonDatosValidosAvance(index)) {
			return;
		}
		this.DataService.post(`proyectos/avancefisico`, value)
			.then(response=>{
				if (response) {
					value.id_avance_fisico= response.datos.id_avance_fisico
					this.Message.success("Actualizado correctamente.");
				}
			})
		value.edicion = false;
	}

	eliminarAvance(value,index){
		//Elimina el registro nuevo del avance fisico
		if (!value.id_avance_fisico) {
		this.proyecto.seguimiento.avance_fis.splice(index, 1);
			return;
		}
	}

	sonDatosValidosAvance(posicion) {
		// Validar avance fisico
		const FORM = angular.element(document.querySelector(`[name=form_avance`)).scope()['form_avance'];
		let esValido = (
			FORM['fecha_'+posicion].$valid &&
			FORM['porcentaje_'+posicion].$valid &&
			FORM['situacion_actual_'+posicion].$valid
		);

		if (!esValido) {
			FORM['fecha_'+posicion].$setTouched();
			FORM['porcentaje_'+posicion].$setTouched();
			FORM['situacion_actual_'+posicion].$setTouched();

			this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
			return false;
		}
		return true;
	}

	sonDatosValidosInspeccion(posicion) {
		// Validar avance fisico
		const FORM = angular.element(document.querySelector(`[name=form_inspeccion`)).scope()['form_inspeccion'];
		let esValido = (
			FORM['fecha_inspeccion_'+posicion].$valid &&
			FORM['listaTecnico_'+posicion].$valid &&
			FORM['detalle_inf_'+posicion].$valid
		);

		if (!esValido) {
			FORM['fecha_inspeccion_'+posicion].$setTouched();
			FORM['listaTecnico_'+posicion].$setTouched();
			FORM['detalle_inf_'+posicion].$setTouched();

			this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
			return false;
		}
		return true;
	}

	guardarAdendas(){
		// console.log(this.proyecto.convenio,"<<<---")
		this.data = {
			id_proyecto: this.proyecto.id_proyecto,
			datos : this.proyecto.convenio,
			estado_proyecto: this.proyecto.estado_proyecto
		}
		this.DataService.post(`proyectos/adendas`,this.data)
			.then(response=>{
				if(response){
					this.Message.success("Proyecto actualizado correctamente.");
					
					this.Loading.hide();
					
				}
			})

	}

	calcularPlazos(){
		this.plazo_convenio0 = new Date(this.proyecto.orden_proceder);
		this.plazo_convenio0.setDate(this.plazo_convenio0.getDate() + parseInt(this.proyecto.plazo_ejecucion))
		this.plazo_convenio0 = this.plazo_convenio0.toISOString();
	}
	recalcularPlazoConvenio1() {
		if (this.plazo_convenio0) {
			this.plazo_convenio1 = new Date(this.plazo_convenio0);
			this.plazo_convenio1.setDate(this.plazo_convenio1.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado))
			this.plazo_convenio1 = this.plazo_convenio1.toISOString();
		}
	}
	recalcularPlazoConvenio2() {
		if (this.plazo_convenio1 && this.proyecto.convenio.plazo_convenio_ampliado2>=0) {
			this.plazo_convenio2 = new Date(this.plazo_convenio1);
			this.plazo_convenio2.setDate(this.plazo_convenio2.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado2))
			this.plazo_convenio2 = this.plazo_convenio2.toISOString();
		}
	}
	recalcularPlazoConvenio3() {
		if (this.plazo_convenio2 && this.proyecto.convenio.plazo_convenio_ampliado3>=0) {
			this.plazo_convenio3 = new Date(this.plazo_convenio2);
			this.plazo_convenio3.setDate(this.plazo_convenio3.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado3))
			this.plazo_convenio3 = this.plazo_convenio3.toISOString();
		}
	}
	recalcularPlazoConvenio4() {
		if (this.plazo_convenio3 && this.proyecto.convenio.plazo_convenio_ampliado4>=0) {
			this.plazo_convenio4 = new Date(this.plazo_convenio3);
			this.plazo_convenio4.setDate(this.plazo_convenio4.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado4))
			this.plazo_convenio4 = this.plazo_convenio4.toISOString();
		}
	}
	recalcularPlazoConvenio5() {
		if (this.plazo_convenio4 && this.proyecto.convenio.plazo_convenio_ampliado5>=0) {
			this.plazo_convenio5 = new Date(this.plazo_convenio4);
			this.plazo_convenio5.setDate(this.plazo_convenio5.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado5))
			this.plazo_convenio5 = this.plazo_convenio5.toISOString();
		}
	}
	recalcularPlazoConvenio6() {
		if (this.plazo_convenio5 && this.proyecto.convenio.plazo_convenio_ampliado6>=0) {
			this.plazo_convenio6 = new Date(this.plazo_convenio5);
			this.plazo_convenio6.setDate(this.plazo_convenio6.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado6))
			this.plazo_convenio6 = this.plazo_convenio6.toISOString();
		}
	}
	recalcularPlazoConvenio7() {
		if (this.plazo_convenio6 && this.proyecto.convenio.plazo_convenio_ampliado7>=0) {
			this.plazo_convenio7 = new Date(this.plazo_convenio6);
			this.plazo_convenio7.setDate(this.plazo_convenio7.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado7))
			this.plazo_convenio7 = this.plazo_convenio7.toISOString();
		}
	}
	recalcularPlazoConvenio8() {
		if (this.plazo_convenio7 && this.proyecto.convenio.plazo_convenio_ampliado8>=0) {
			this.plazo_convenio8 = new Date(this.plazo_convenio7);
			this.plazo_convenio8.setDate(this.plazo_convenio8.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado8))
			this.plazo_convenio8 = this.plazo_convenio8.toISOString();
		}
	}
	recalcularPlazoConvenio9() {
		if (this.plazo_convenio8 && this.proyecto.convenio.plazo_convenio_ampliado9>=0) {
			this.plazo_convenio9 = new Date(this.plazo_convenio8);
			this.plazo_convenio9.setDate(this.plazo_convenio9.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado9))
			this.plazo_convenio9 = this.plazo_convenio9.toISOString();
		}
	}
	recalcularPlazoConvenio10() {
		if (this.plazo_convenio9 && this.proyecto.convenio.plazo_convenio_ampliado10>=0) {
			this.plazo_convenio10 = new Date(this.plazo_convenio9);
			this.plazo_convenio10.setDate(this.plazo_convenio10.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado10))
			this.plazo_convenio10 = this.plazo_convenio10.toISOString();
		}
	}
	recalcularPlazoConvenio11() {
		if (this.plazo_convenio10 && this.proyecto.convenio.plazo_convenio_ampliado11>=0) {
			this.plazo_convenio11 = new Date(this.plazo_convenio10);
			this.plazo_convenio11.setDate(this.plazo_convenio11.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado11))
			this.plazo_convenio11 = this.plazo_convenio11.toISOString();
		}
	}
	recalcularPlazoConvenio12() {
		if (this.plazo_convenio11 && this.proyecto.convenio.plazo_convenio_ampliado12>=0) {
			this.plazo_convenio12 = new Date(this.plazo_convenio11);
			this.plazo_convenio12.setDate(this.plazo_convenio12.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado12))
			this.plazo_convenio12 = this.plazo_convenio12.toISOString();
		}
	}
	recalcularPlazoConvenio13() {
		if (this.plazo_convenio12 && this.proyecto.convenio.plazo_convenio_ampliado13>=0) {
			this.plazo_convenio13 = new Date(this.plazo_convenio12);
			this.plazo_convenio13.setDate(this.plazo_convenio13.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado13))
			this.plazo_convenio13 = this.plazo_convenio13.toISOString();
		}
	}
	recalcularPlazoConvenio14() {
		if (this.plazo_convenio13 && this.proyecto.convenio.plazo_convenio_ampliado14>=0) {
			this.plazo_convenio14 = new Date(this.plazo_convenio13);
			this.plazo_convenio14.setDate(this.plazo_convenio14.getDate() + parseInt(this.proyecto.convenio.plazo_convenio_ampliado14))
			this.plazo_convenio14 = this.plazo_convenio14.toISOString();
		}
	}
	derivarProyecto(){
		this.Modal.confirm( `¿Está seguro/a de derivar el proceso a la siguiente instancia?`, () => {
			let estadoDestino = {
					id_proyecto:this.proyecto.id_proyecto,
					estado_proyecto:'REVISION_SEGUIMIENTO_FDI'
				}
		this.DataService.post(`proyectos/derivar`, estadoDestino)
			.then(response=>{
				if (response) {
					this.Message.success("Proyecto derivado correctamente.")
					this.respuesta = response;
					// console.log(this.respuesta,"response")
					this.usuario = this.Storage.getUser();
					this.$state.go(this.usuario.pathInicio.replace('/',''));
				}
			})
		}, null, 'Confirmar envío', 'Si, estoy seguro/a', 'Cancelar');

	}

	devolverProyecto(){
		
		let modalObservacion = this.Modal.show({
			template: modalObservacionTemplate,
			controller: modalObservacionController,
			data: {},
			size:'md'
		});
		modalObservacion.result.then((elementoActualizado) => {
			// console.log("detalle de observacion : ", elementoActualizado)
			let estadoDestino = {
								id_proyecto:this.proyecto.id_proyecto,
								estado_proyecto:'EN_EJECUCION_FDI',
								observacion: elementoActualizado.observacion
							}
			this.DataService.post(`proyectos/derivar`, estadoDestino)
				.then(response=>{
					if (response) {
						this.Message.success("Proyecto derivado correctamente.")
						this.respuesta = response;
						// console.log(this.respuesta,"response")
						this.usuario = this.Storage.getUser();
						this.$state.go(this.usuario.pathInicio.replace('/',''));
					}
				})		
		}).catch(() => {});

	}
	enviarACierre(){
		this.Message.warning("En desarrollo...")
	}

	
}

export default SeguimientoController;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/seguimiento/seguimiento.controller.js